import styled from 'styled-components'

export const Button = styled.button<{isSelected: boolean}>`
  display: flex;
  height: 40px;
  justify-content: center;
  align-items: center;
  border-radius:  4px;
  border: 1px solid #3E3E47;
  background: #FFF;
  color:  #3E3E47;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;
  padding: 0;
  text-align: center;
  flex-grow: 1;

  ${({ isSelected }) => isSelected && `
    color: #FFF;
    background: #282832;
  `}
`

export const ButtonIcon = styled.div`
  display: flex;
  padding-right: 8px;
`
